const APP_URL = config.studyLink;
const APP_URL_ENCODED = encodeURIComponent(APP_URL);
const EMBED_URL = config.embedUrl;
const SHARING_TEXT_ENCODED = encodeURIComponent(config.sharingText);

export function getHrefFb() {
  return `https://www.facebook.com/sharer/sharer.php?u=${APP_URL_ENCODED}&t=${SHARING_TEXT_ENCODED}`;
}

export function getHrefTw() {
  return `https://twitter.com/intent/tweet?url=${APP_URL_ENCODED}&text=${SHARING_TEXT_ENCODED}`;
}

export function getEmbedCode() {
  return (`<iframe width="100%" height="960" src="${EMBED_URL}" frameborder="0" allowfullscreen></iframe>`);
}

export default {
  getEmbedCode,
  getHrefFb,
  getHrefTw
};
